import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { MascotDoodle } from "@/components/brand/MascotDoodle";

export default function NotFound() {
  return (
    <div className="mx-auto grid max-w-[1440px] items-center gap-12 px-5 py-24 sm:px-10 lg:grid-cols-12 lg:py-32" data-testid="not-found-page">
      <Seo title="404: Lost in the alleys" description="This page went missing. Kinda sus." path={window.location.pathname} noindex />
      <div className="lg:col-span-7">
        <p className="label text-ink/50">Error 404</p>
        <h1 className="display mt-5 text-[clamp(4rem,10vw,8.75rem)]">This page<br />is sus.</h1>
        <p className="mt-8 max-w-md text-[15px] leading-relaxed text-ink/70">Looks like you got lost in the alleys of Toronto. The page you're after doesn't exist or has moved.</p>
        <Link to="/" className="btn btn-ink mt-10" data-testid="not-found-home-link">Back to home <ArrowRight size={16} /></Link>
      </div>
      <div className="flex justify-center lg:col-span-5 lg:justify-end">
        <div data-testid="not-found-mascot" className="w-[60%] max-w-[340px] lg:w-full"><MascotDoodle variant="tongue" size={340} label="Mascot sticking its tongue out" className="w-full" /></div>
      </div>
    </div>
  );
}
